export default __webpack_public_path__ + "static/media/ternary.e8bc22f7.png";